export default __webpack_public_path__ + "static/media/tie.0f3a4caf.svg";